export default (timeZone, intl) =>
  timeZone
    ? intl.formatMessage(
        {
          id: 'Local_time_timezone'
        },
        {timeZone}
      )
    : '';
